import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, Field, formValueSelector, change } from 'redux-form'
import labelAndInput from '../common/form/labelAndInput'
import RadioSimNao from '../common/form/radioSimNao'
import textArea from '../common/form/textArea'
import Select from '../common/form/select'
import { createNumberMask, createTextMask } from 'redux-form-input-masks';

import { init } from './unidadeAction'
import util from '../util/util'

import {parsePemCertificate} from '../util/DecodeCertificado';


const currencyMask = createNumberMask({
    prefix: '',
    suffix: '',
    decimalPlaces: 2,
    locale: 'pt-br',
})


class UnidadeForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            desativaPercentualDesconto: true, desativaValorDesconto: true,
            desativaPercentualMulta: true, desativaValorMulta: true,
            desativaPercentualJuro: true, desativaValorJuro: true
        }
    }


    handleChange = event => {
        this.desativaEdtValorPercentualDesconto(event.target.value)
    };

    desativaEdtValorPercentualDesconto = (tipoDesconto) => {
        let edtValor = true;
        let edtPercentual = true;

        if (tipoDesconto == 0) {
            edtValor = true;
            edtPercentual = true;
            this.props.dispatch(change('unidadeForm', 'valor_desconto', '0'));
            this.props.dispatch(change('unidadeForm', 'percentual_desconto', '0'));
        }
        if (tipoDesconto == 1) {
            edtValor = false;
            edtPercentual = true;
            this.props.dispatch(change('unidadeForm', 'percentual_desconto', '0'));
        }
        if (tipoDesconto == 2 || tipoDesconto == 3) {
            edtValor = true;
            edtPercentual = false;
            this.props.dispatch(change('unidadeForm', 'valor_desconto', '0'));
        }

        this.setState({ ...this.state, desativaValorDesconto: edtValor, desativaPercentualDesconto: edtPercentual })
    }


    tipoJuroChange = event => {
        this.desativaEdtValorPercentualJuro(event.target.value)
    };

    desativaEdtValorPercentualJuro = (tipoJuro) => {
        let edtValorJuro = true;
        let edtPercentualJuro = true;
        //console.log('TIPO JURO ' + tipoJuro)

        if (tipoJuro == 0 || tipoJuro == 3) {
            edtValorJuro = true;
            edtPercentualJuro = true;
            this.props.dispatch(change('unidadeForm', 'valor_juro', '0'));
            this.props.dispatch(change('unidadeForm', 'percentual_juro', '0'));
        }
        if (tipoJuro == 1) {
            edtValorJuro = false;
            edtPercentualJuro = true;
            this.props.dispatch(change('unidadeForm', 'percentual_juro', '0'));
        }
        if (tipoJuro == 2) {
            edtValorJuro = true;
            edtPercentualJuro = false;
            this.props.dispatch(change('unidadeForm', 'valor_juro', '0'));
        }

        this.setState({ ...this.state, desativaValorJuro: edtValorJuro, desativaPercentualJuro: edtPercentualJuro })
    }

    tipoMultaChange = event => {
        this.desativaEdtValorPercentualMulta(event.target.value)
    };
    desativaEdtValorPercentualMulta = (tipoMulta) => {
        let edtValorMulta = true;
        let edtPercentualMulta = true;

        if (tipoMulta == 0 || tipoMulta == 3) {
            edtValorMulta = true;
            edtPercentualMulta = true;
            this.props.dispatch(change('unidadeForm', 'valor_multa', '0'));
            this.props.dispatch(change('unidadeForm', 'percentual_multa', '0'));
        }
        if (tipoMulta == 1) {
            edtValorMulta = false;
            edtPercentualMulta = true;
            this.props.dispatch(change('unidadeForm', 'percentual_multa', '0'));
        }
        if (tipoMulta == 2) {
            edtValorMulta = true;
            edtPercentualMulta = false;
            this.props.dispatch(change('unidadeForm', 'valor_multa', '0'));
        }

        this.setState({ ...this.state, desativaValorMulta: edtValorMulta, desativaPercentualMulta: edtPercentualMulta })
    }

    componentDidMount() {
        /*   console.log(this.state)
           this.desativaEdtValorPercentualDesconto(this.props.tipo_desconto)
           console.log(this.state)
           this.desativaEdtValorPercentualJuro(this.props.tipo_juro)
           console.log(this.state)
           this.desativaEdtValorPercentualMulta(this.props.tipo_multa)
           console.log(this.state)*/

        let tipoMulta = this.props.tipo_multa;
        let tipoDesconto = this.props.tipo_desconto;
        let tipoJuro = this.props.tipo_juro;

        let edtValorMulta = true;
        let edtPercentualMulta = true;

        if (tipoMulta == 0 || tipoMulta == 3) {
            edtValorMulta = true;
            edtPercentualMulta = true;
        }
        if (tipoMulta == 1) {
            edtValorMulta = false;
            edtPercentualMulta = true;
        }
        if (tipoMulta == 2) {
            edtValorMulta = true;
            edtPercentualMulta = false;
        }

        let edtValorJuro = true;
        let edtPercentualJuro = true;

        if (tipoJuro == 0 || tipoJuro == 3) {
            edtValorJuro = true;
            edtPercentualJuro = true;
        }
        if (tipoJuro == 1) {
            edtValorJuro = false;
            edtPercentualJuro = true;
        }
        if (tipoJuro == 2) {
            edtValorJuro = true;
            edtPercentualJuro = false;
        }

        let edtValor = true;
        let edtPercentual = true;

        if (tipoDesconto == 0) {
            edtValor = true;
            edtPercentual = true;
        }
        if (tipoDesconto == 1) {
            edtValor = false;
            edtPercentual = true;
        }
        if (tipoDesconto == 2 || tipoDesconto == 3) {
            edtValor = true;
            edtPercentual = false;
        }

        //console.log(this.props.certificado)
        if (this.props.certificado != null) {

            var dataVencimento;
                try {
                    const info = parsePemCertificate(this.props.certificado);
            //printCertificateInfo(info);

            // Verificar se expira em menos de 30 dias
            if (info.validity.daysRemaining <= 30 && !info.validity.isExpired) {
                //console.warn(`⚠️  Certificado expira em ${info.validity.daysRemaining} dias!`);
                this.setState({ ...this.state, validade_certificado: `⚠️  Certificado expira em ${info.validity.daysRemaining} dias!`})
            }
             // Verificar se expira em menos de 30 dias
            if (info.validity.daysRemaining >= 30 && !info.validity.isExpired) {
                //console.warn(`⚠️  Certificado expira em ${info.validity.daysRemaining} dias!`);
                this.setState({ ...this.state, validade_certificado: 'Válido até: ' + info.validity.notAfterFormatted })
            }

            if (info.validity.isExpired) {
                //console.error('❌ Certificado EXPIRADO!');
                this.setState({ ...this.state, validade_certificado: '❌ Certificado EXPIRADO!' })
            }

        } catch (err) {
            console.error('Erro ao decodificar certificado:', err.message);
        }



        //var dataVencimento = util.obterVencimentoCertificado2(this.props.certificado);
        //console.log(dataVencimento.toLocaleString())
        //this.setState({ ...this.state, validade_certificado: 'Válido até: ' + dataVencimento.toLocaleString() })
    }

        this.setState({ ...this.state, desativaValorDesconto: edtValor, desativaPercentualDesconto: edtPercentual, desativaValorJuro: edtValorJuro, desativaPercentualJuro: edtPercentualJuro, desativaValorMulta: edtValorMulta, desativaPercentualMulta: edtPercentualMulta })

    }




getListaTipoDesconto = () => {
    let lista = []
    lista.push({ chave: 0, valor: "Sem Desconto" });
    lista.push({ chave: 1, valor: "Valor Fixo" });
    lista.push({ chave: 2, valor: "Percentual" });
    //lista.push({ chave: 3, valor: "Dias Antecipação" });
    return lista;
}

getListaTipoJuro = () => {
    let lista = []
    lista.push({ chave: 0, valor: "Sem Juros" });
    lista.push({ chave: 1, valor: "Valor Dia Atraso" });
    lista.push({ chave: 2, valor: "Taxa Mensal" });
    //lista.push({ chave: 3, valor: "Dias Antecipação" });
    return lista;
}

getListaTipoMulta = () => {
    let lista = []
    lista.push({ chave: 0, valor: "Sem Multa" });
    lista.push({ chave: 1, valor: "Valor Multa" });
    lista.push({ chave: 2, valor: "Percentual" });
    //lista.push({ chave: 3, valor: "Dias Antecipação" });
    return lista;
}



getListaBancos = () => {
    let list = []
    list.push({ chave: "001", valor: "Banco do Brasil S.A." });
    list.push({ chave: "461", valor: "ASAAS GESTÃO FINANCEIRA INSTITUIÇÃO DE PAGAMENTO S.A." });
    list.push({ chave: "756", valor: "Banco Sicoob" });
    return list;
}

render() {
    const { handleSubmit, readOnly } = this.props


    return (
        <form role='form' onSubmit={handleSubmit}>

            <div className="box-body">

                {/*<Field name='Campo de Pesquisa' component={InputPesquisa}
                        label='Campo de Pesquisa'
                        cols='12 4'
                        placeholder='Informe a pesquisa'
                        readOnly={readOnly}
        valueDesc='' />*/}

                <Field name='id' component={labelAndInput}
                    label='Id'
                    cols='12 2'
                    placeholder='Id'
                    readOnly={true} />

                <Field name='id_unidade_controle' component={labelAndInput}
                    label='Id Controle'
                    cols='12 2'
                    placeholder='Informe Id Controle'
                    readOnly={readOnly} />

                <Field name='nome' component={labelAndInput}
                    label='Nome'
                    cols='12 4'
                    placeholder='Informe o nome'
                    readOnly={readOnly} />

                <Field name='nome_fantasia' component={labelAndInput}
                    cols='12 4'
                    label='Nome Fantasia' placeholder='Informe o Nome Fantasia'
                    readOnly={readOnly} />

                {/* final da primeira linha */}

                <Field name='cnpj' component={labelAndInput}
                    label='CNPJ'
                    cols='12 2'
                    placeholder='Informe o CNPJ'
                    readOnly={readOnly} />

                <Field name='endereco' component={labelAndInput}
                    type='text' cols='12 5'
                    label='Endereço' placeholder='Informe o Endereço'
                    readOnly={readOnly} />

                <Field name='bairro' component={labelAndInput}
                    type='text' cols='12 5'
                    label='Bairro' placeholder='Informe o Bairro'
                    readOnly={readOnly} />
                {/* final da segunda linha */}

                <Field name='municipio' component={labelAndInput}
                    type='text' cols='12 6'
                    label='Município' placeholder='Informe o Município'
                    readOnly={readOnly} />

                <Field name='cep' component={labelAndInput}
                    type='text' cols='12 2'
                    label='CEP' placeholder='Informe o CEP'
                    readOnly={readOnly} />

                <Field name='uf' component={labelAndInput}
                    type='text' cols='12 1'
                    label='Uf' placeholder='Informe a UF'
                    readOnly={readOnly} />

                <Field name='agencia' component={labelAndInput}
                    type='text' cols='12 2'
                    label='Agência' placeholder='Informe a Agência'
                    readOnly={readOnly} />

                <Field name='agencia_dv' component={labelAndInput}
                    type='text' cols='12 1'
                    label='DV' placeholder='DV'
                    readOnly={readOnly} />

                {/* final da terceira linha */}

                <Field name='conta_corrente' component={labelAndInput}
                    type='text' cols='12 4'
                    label='Conta Corrente' placeholder='Informe a Conta Corrente'
                    readOnly={readOnly} />

                <Field name='conta_corrente_dv' component={labelAndInput}
                    type='text' cols='12 1'
                    label='DV' placeholder='DV'
                    readOnly={readOnly} />

                <Field name='convenio' component={labelAndInput}
                    type='text' cols='12 3'
                    label='Convênio' placeholder='Informe o Convênio'
                    readOnly={readOnly} />



                <Field name='carteira' component={labelAndInput}
                    type='text' cols='12 2'
                    label='Carteira' placeholder=''
                    readOnly={readOnly} />

                <Field name='variacao_carteira' component={labelAndInput}
                    type='text' cols='12 2'
                    label='Variação Carteira' placeholder=''
                    readOnly={readOnly} />
                <Field name='cedente' component={labelAndInput}
                    type='text' cols='12 1'
                    label='Código Cedente' placeholder=''
                    readOnly={readOnly} />

                <Field name='cedente_dv' component={labelAndInput}
                    type='text' cols='12 1'
                    label='DV Cedente' placeholder=''
                    readOnly={readOnly} />
                {/* final da quarta linha */}

                {/*  <Field name='perc_juros' component={labelAndInput}
                        type='text' cols='12 2'
                        label='% Juros' placeholder=''
                        readOnly={readOnly} />

                    <Field name='perc_multa' component={labelAndInput}
                        type='text' cols='12 2'
                        label='% Multa' placeholder=''
    readOnly={readOnly} />*/}

                <Field name='ativo' component={RadioSimNao}
                    cols='12 2'
                    label='Status'
                    valueSim={true}
                    valueNao={false}
                    descSim={'Ativo'}
                    descNao={'Inativo'}
                    readOnly={readOnly} />

                <Field name='tipo_desconto' component={Select}
                    cols='12 4'
                    label='Tipo Desconto (Válido até a Data de Venc.)'
                    lista={this.getListaTipoDesconto()}
                    onChange={this.handleChange}
                    readOnly={readOnly} />
                <Field name='valor_desconto' component={labelAndInput}
                    type='numeric' cols='12 2'
                    label='Valor Desconto'
                    placeholder='Valor Desconto'
                    className='valor_monetario form-control'
                    pattern="[0-9]*"
                    inputMode="numeric"
                    {...currencyMask}
                    readOnly={this.state.desativaValorDesconto} />

                <Field name='percentual_desconto' component={labelAndInput}
                    type='numeric' cols='12 2'
                    label='Percentual Desconto'
                    placeholder='Percentual Desconto'
                    className='valor_monetario form-control'
                    pattern="[0-9]*"
                    inputMode="numeric"
                    {...currencyMask}
                    readOnly={this.state.desativaPercentualDesconto} />






                <Field name='tipo_multa' component={Select}
                    cols='12 2'
                    label='Tipo Multa'
                    lista={this.getListaTipoMulta()}
                    onChange={this.tipoMultaChange}
                    readOnly={readOnly} />
                <Field name='valor_multa' component={labelAndInput}
                    type='numeric' cols='12 2'
                    label='Valor multa'
                    placeholder='Valor Multa'
                    className='valor_monetario form-control'
                    pattern="[0-9]*"
                    inputMode="numeric"
                    {...currencyMask}
                    readOnly={this.state.desativaValorMulta} />

                <Field name='percentual_multa' component={labelAndInput}
                    type='numeric' cols='12 2'
                    label='Percentual Multa'
                    placeholder='Percentual Multa'
                    className='valor_monetario form-control'
                    pattern="[0-9]*"
                    inputMode="numeric"
                    {...currencyMask}
                    readOnly={this.state.desativaPercentualMulta} />

                <Field name='tipo_juro' component={Select}
                    cols='12 2'
                    label='Tipo Juro'
                    lista={this.getListaTipoJuro()}
                    onChange={this.tipoJuroChange}
                    readOnly={readOnly} />
                <Field name='valor_juro' component={labelAndInput}
                    type='numeric' cols='12 2'
                    label='Valor Juro'
                    placeholder='Valor Juro'
                    className='valor_monetario form-control'
                    pattern="[0-9]*"
                    inputMode="numeric"
                    {...currencyMask}
                    readOnly={this.state.desativaValorJuro} />

                <Field name='percentual_juro' component={labelAndInput}
                    type='numeric' cols='12 2'
                    label='Percentual Juro'
                    placeholder='Percentual Juro'
                    className='valor_monetario form-control'
                    pattern="[0-9]*"
                    inputMode="numeric"
                    {...currencyMask}
                    readOnly={this.state.desativaPercentualJuro} />




                <Field name='instituicao_financ' component={Select}
                    cols='12 6'
                    label='Instituição Financeira'
                    lista={this.getListaBancos()}
                    readOnly={readOnly} />

                <Field name='instrucao_boleto' component={textArea}
                    id='instrucao_boleto'
                    cols='12 12'
                    type="textare"
                    label='Instrução Boleto'
                    readOnly={readOnly} />

                <Field name='bb_app_key' component={labelAndInput}
                    type='password' cols='12 12'
                    label='App_Key' placeholder='Informe a chave app_key Fornecida pelo Banco Brasil'
                    readOnly={readOnly} />
                <Field name='bb_client_id' component={labelAndInput}
                    type='password' cols='12 12'
                    label='Client_id' placeholder='Informe a chave client_id Fornecida pelo Banco'
                    readOnly={readOnly} />
                <Field name='bb_client_secret' component={labelAndInput}
                    type='password' cols='12 12'
                    label='Client_secret' placeholder='Informe a chave client_secret Fornecida pelo Banco'
                    readOnly={readOnly} />
                <Field name='bb_basic_token' component={labelAndInput}
                    type='password' cols='12 12'
                    label='Basic_token' placeholder='Informe a chave bb_basic_token Fornecida pelo Banco'
                    readOnly={readOnly} />

                <Field name='certificado' component={textArea}
                    id='certificado'
                    cols='12 6'
                    type="textare"
                    label={this.state.validade_certificado != undefined ? 'Certificado ' + this.state.validade_certificado : 'Certificado'}
                    readOnly={readOnly} />
                <Field name='key_certificado' component={textArea}
                    cols='12 6'
                    id='chave_certificado'
                    type="textare"
                    label='Chave Privada(Certificado)'
                    readOnly={readOnly} />

            </div>

            <div className="boxfooter">
                <button type='submit'
                    className={`btn btn-${this.props.submitClass}`}>
                    <i className={`fa fa-${this.props.iconSubmit}`}></i>
                    <span className='space-icon'>{this.props.submitLabel}</span>
                </button>
                <button type='button' className="btn btn-default"
                    onClick={this.props.init} ><i className="fa fa-ban"></i><span className='space-icon'>Cancelar</span></button>
            </div>
        </form>
    )
}
}

UnidadeForm = reduxForm({ form: 'unidadeForm', destroyOnUnmount: false })(UnidadeForm)
const selector = formValueSelector('unidadeForm')

const mapStateToProps = state => ({
    usuario: state.auth.user,
    tipo_desconto: selector(state, "tipo_desconto"), valor_desconto: selector(state, "valor_desconto"), percentual_desconto: selector(state, "percentual_desconto"),
    tipo_juro: selector(state, "tipo_juro"), valor_juro: selector(state, "valor_juro"), percentual_juro: selector(state, "percentual_juro"),
    tipo_multa: selector(state, "tipo_multa"), valor_multa: selector(state, "valor_multa"), percentual_multa: selector(state, "percentual_multa"),
    certificado: selector(state, "certificado")
})
const mapDispatchToProps = dispatch => bindActionCreators({
    init, changeFieldValue: function (field, value) {
        dispatch(change('unidadeForm', field, value))
    }
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(UnidadeForm)



// WEBPACK FOOTER //
// ./src/unidade/unidadeForm.jsx